// extracted by mini-css-extract-plugin
module.exports = {"anim":"FadeInAnim_anim__3PMCq","animation":"FadeInAnim_animation__Kg_H3"};